export const getUrlMobileApp = (accessToken: string) =>
    `reops://?token=${accessToken}`;
